import { render, staticRenderFns } from "./NewSubjectRemoveSemester.vue?vue&type=template&id=22fbad17&"
import script from "./NewSubjectRemoveSemester.vue?vue&type=script&lang=js&"
export * from "./NewSubjectRemoveSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports